import { request, Row } from './request';
import AppError from './models/common/res/AppError';
import { ReviewForm } from './models/review/res/ReviewForm';
import { AddReviewResponseBody } from './models/review/req/AddReviewResponseBody';

const apiRootUrl = '/customer/v2/reservation-reviews';

/**
 * 리뷰 등록
 */
export const addReviewResponse = async (
  partnerCode: string,
  body: AddReviewResponseBody,
) => {
  try {
    await request({
      method: 'post',
      url: apiRootUrl,
      requestBody: {
        ...body,
        partnerCode,
      },
    });
    return;
  } catch (e) {
    throw new AppError(e);
  }
};

/**
 * 리뷰 폼 설정 값 조회
 */
export const fetchReviewForm = async (reservationId: number | string) => {
  const url = `${apiRootUrl}/${reservationId}/form`;
  try {
    const res = await request<Row<ReviewForm>>({
      method: 'get',
      url,
    });
    const { data } = res;
    const { row } = data;
    return row;
  } catch (e) {
    throw new AppError(e);
  }
};

/**
 * 리뷰 정보 조회
 */
export const fetchReviewResponseAvailable = async (
  reservationId: number | string,
) => {
  const url = `${apiRootUrl}/${reservationId}/response-available`;
  try {
    await request({
      method: 'get',
      url,
    });
    return;
  } catch (e) {
    throw new AppError(e);
  }
};
